'use strict';

var angularModule = angular.module('t2g.common.services.loading-indocator', []);

module.exports = angularModule;

angularModule.factory('LoadingIndicatorService', function($rootScope) {
  hide();

  $rootScope.showLoadingIndicator = 0;

  return {
    hide: hide,
    show: show,
  };

  function hide() {
    $rootScope.showLoadingIndicator--;
  }

  function show() {
    $rootScope.showLoadingIndicator++;
  }
});



// WEBPACK FOOTER //
// ./src/app/common/services/loadingIndicator.js